var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8616 0.195262C10.122 -0.0650874 10.5441 -0.0650874 10.8044 0.195262L13.4711 2.86193C13.7314 3.12228 13.7314 3.54439 13.4711 3.80474L10.8044 6.4714C10.5441 6.73175 10.122 6.73175 9.8616 6.4714C9.60125 6.21106 9.60125 5.78895 9.8616 5.5286L12.0569 3.33333L9.8616 1.13807C9.60125 0.877722 9.60125 0.455612 9.8616 0.195262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66634 4C3.13591 4 2.6272 4.21071 2.25213 4.58579C1.87705 4.96086 1.66634 5.46957 1.66634 6V7.33333C1.66634 7.70152 1.36786 8 0.999674 8C0.631485 8 0.333008 7.70152 0.333008 7.33333V6C0.333008 5.11595 0.684197 4.2681 1.30932 3.64298C1.93444 3.01786 2.78229 2.66667 3.66634 2.66667H12.9997C13.3679 2.66667 13.6663 2.96514 13.6663 3.33333C13.6663 3.70152 13.3679 4 12.9997 4H3.66634Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13775 9.5286C4.3981 9.78895 4.3981 10.2111 4.13775 10.4714L1.94248 12.6667L4.13775 14.8619C4.3981 15.1223 4.3981 15.5444 4.13775 15.8047C3.8774 16.0651 3.45529 16.0651 3.19494 15.8047L0.52827 13.1381C0.26792 12.8777 0.26792 12.4556 0.52827 12.1953L3.19494 9.5286C3.45529 9.26825 3.8774 9.26825 4.13775 9.5286Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9997 8C13.3679 8 13.6663 8.29848 13.6663 8.66667V10C13.6663 10.8841 13.3152 11.7319 12.69 12.357C12.0649 12.9821 11.2171 13.3333 10.333 13.3333H0.999674C0.631485 13.3333 0.333008 13.0349 0.333008 12.6667C0.333008 12.2985 0.631485 12 0.999674 12H10.333C10.8634 12 11.3721 11.7893 11.7472 11.4142C12.1223 11.0391 12.333 10.5304 12.333 10V8.66667C12.333 8.29848 12.6315 8 12.9997 8Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvert);
export default __webpack_public_path__ + "static/media/convert.ba7d1f36.svg";
export { ForwardRef as ReactComponent };